/* eslint eqeqeq: "off" */
import React, { useState, useRef, useEffect } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Image,
  Input,
  // InputNumber,
  Modal,
  Row,
  Select,
  // Space,
  Tooltip,
  Typography,
  FloatButton,
  Collapse,
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import {
  SettingOutlined,
  PlusOutlined,
  CloseOutlined,
  DownCircleOutlined,
  QuestionCircleOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { isEmpty } from "lodash";
import { balaceCollectOptions, partyFaqList } from "./data";
import customFieldsLogo from "../../assets/images/empty-party-custom-field.svg";
import customModalLogo from "../../assets/images/party-custom-field.svg";
import { emailIsValid } from "../Auth/validations";
import axios from "axios";
import { useHistory } from "react-router";
// import { Prompt } from "react-router-dom";
// import { Prompt } from "react-router-dom";
import "./index.css";
import useBeforeUnload from "../../components/Prompting";
import {
  loadVendor,
  loadVendorRecordsMetaData,
} from "../../store/vendor/actions";
import { useDispatch, useSelector } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import {
  createVendorCategoryList,
  loadVendorCategory,
} from "../../store/vendor/actions";
import api from "../../helpers";

const AddVendor = (props) => {
  const dispatch = useDispatch();
  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  //Props values from vendor home page
  // const recordsMetaData = props.location.state
  //   ? props.location.state.metaData
  //   : "";
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);
  const organizationId =
    !isEmpty(userNameDetails) && userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";
  const selectionVendorData =
    props.location && props.location.state
      ? props.location.state.vendorData
      : "";
  const userId =
    props.location && props.location.state ? props.location.state.userId : "";
  // const vendorListId = props.location.state
  //   ? props.location.state.itemList
  //   : "";
  const vendorListId = { organizationId: organizationId };
  useEffect(() => {
    dispatch(loadVendorRecordsMetaData());
    dispatch(loadVendorCategory(vendorListId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { category_list = [], recordsMetaData = {} } = useSelector(
    (state) => state.Vendor
  );

  const categoryOptions =
    category_list.length > 0
      ? category_list.map((c) => {
          return {
            label: c.categoryName,
            shortCode: c.shortCode,
            value: c._id,
          };
        })
      : [];

  //Party State values
  const [vendorName, setVendorName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [vendorData, setVendorData] = useState({
    vendorName: "",
    displayName: "",
    creditBalance: "",
    mobileNumber: "",
    email: "",
    toCollectAmount: "",
    gstNo: "",
    panNo: "",
    billingAddress: "",
    shippingAddress: "",
    sameAs: "",
    creditPeriod: "",
    creditLimit: "",
    _id: "",
  });
  const [pageRouting, setPageRouting] = useState(false);
  const history = useHistory();

  const handleChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      // mobileNumber: /^[0-9]*$/, // Only numeric characters allowed
      mobileNumber: /^[0-9]\d*\.?\d*$/,
      creditLimit: /^\d*\.?\d*$/,
      creditPeriod: /^\d*\.?\d*$/,
      creditBalance: /^\d*\.?\d*$/,
      toCollectAmount: /^\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setVendorData({
          ...vendorData,
          [name]: value,
        });
      }
    } else {
      setVendorData({
        ...vendorData,
        [name]: value,
      });
    }
  };

  // const [mouseHover, setMouseHover] = useState([]);
  const [vendorType, setVendorType] = useState([]);
  const [vendorCategory, setVendorCategory] = useState([]);
  const [vendorCategoryId, setVendorCategoryId] = useState("");
  const [collectAmount, setCollectAmount] = useState([]);
  const [gstPercentage, setGstPercentage] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [sameAs, setSameAs] = useState("");
  const [email, setEmail] = useState("");
  const [partyFaq, setPartyFaq] = useState(false);

  console.log(gstPercentage, "gstPercentage");
  //Billing modal states
  const [billingModal, setBillingModal] = useState(false);
  const [addressMode, setAddressMode] = useState("");
  const [stateData, setStateData] = useState([]);
  const [pincode, setPincode] = useState([]);
  const [shippingStateData, setShippingStateData] = useState([]);
  const [shippingPincode, setShippingPincode] = useState([]);

  const [billingData, setBillingData] = useState({
    streetAddress: "",
    city: "",
    stateId: "",
    shippingStateId: "",
    shippingStreetAddress: "",
    shippingCity: "",
  });

  const billingModalChange = (e) => {
    const { name, value } = e.target;

    // const validationRules = {
    //   pincode: /^[0-9]*$/,
    // };
    // if (validationRules[name]) {
    //   if (validationRules[name].test(value) || value === "") {
    //     setBillingData({
    //       ...billingData,
    //       [name]: value,
    //     });
    //   }
    // } else {
    setBillingData({
      ...billingData,
      [name]: value,
    });
    // }
  };

  //Email validation changes
  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
    }
  };

  //Select Categories
  const [categoryName, setCategoryName] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [description, setDescription] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [categoryValidations, setCategoryValidations] = useState(false);
  const [itemCategoryModal, setItemCategoryModal] = useState(false);
  const [categoryAdditionalFields, setCategoryAdditionalFields] = useState("");

  //Custom Fields State values
  const [customFields, setCustomFields] = useState(false);
  // const [customFieldsAdd, setCustomFieldsAdd] = useState(false);
  const [pageRender, setPageRender] = useState(false);

  const handleOk = () => {
    setCustomFields(false);
  };
  const handleCancel = () => {
    setCustomFields(false);
  };

  const [customFieldsData, setCustomFieldsData] = useState([
    {
      fieldName: "",
    },
  ]);

  const addCustomFields = () => {
    setCustomFieldsData([
      ...customFieldsData,
      {
        fieldName: "",
      },
    ]);
    // setCustomFieldsAdd(true);
    setPageRender(!pageRender);
  };
  useBeforeUnload({
    when: !isEmpty(vendorData) || !isEmpty(vendorType),
    message: "Are you sure you want to leave?",
  });
  const removeCustomFields = (index) => {
    const array = customFieldsData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  const handleCustomFieldsChange = (e, name, index) => {
    var fieldList = customFieldsData;
    if (name === "fieldName") {
      fieldList[index][name] = e.target.value;
      setCustomFieldsData(fieldList);
      setPageRender(!pageRender);
    }
  };

  //Custom Fields section end

  //Billing modal
  const billingAddressSubmit = () => {
    if (
      isEmpty(billingData.streetAddress) ||
      isEmpty(billingData.city) ||
      isEmpty(stateData) ||
      isEmpty(pincode)
    ) {
      toast.error("Enter all the required field");
    } else {
      const stateName =
        !isEmpty(stateData) &&
        recordsMetaData &&
        recordsMetaData.stateOptions.length > 0
          ? recordsMetaData.stateOptions.find(
              (data) => data.value === stateData
            )
          : "";
      const stateNameData = !isEmpty(stateName) ? stateName.label : stateData;
      const billingAddressValues =
        billingData.streetAddress +
        ", " +
        billingData.city +
        ", " +
        stateNameData +
        " - " +
        pincode;
      setVendorData({
        ...vendorData,
        billingAddress: billingAddressValues,
        shippingAddress: sameAs === true ? billingAddressValues : "",
      });
      setBillingModal(false);
    }
  };
  const currencyData = "66c89317f4eec74eb828965b";

  const collectAmountValue =
    balaceCollectOptions.length > 0
      ? balaceCollectOptions.find((data) => data.label === "To Pay")
      : "";
  console.log(collectAmountValue, "collectAmountValue");
  const vendorListData = {
    organizationId: organizationId,
    vendorName: vendorName,
    displayName: displayName,
    mobileNo: vendorData.mobileNumber ? vendorData.mobileNumber : "",
    email: email ? email : "",
    openingBalance: vendorData.toCollectAmount
      ? parseInt(vendorData.toCollectAmount)
      : "",
    openingbalanceType:
      collectAmountValue && !isEmpty(collectAmountValue)
        ? collectAmountValue.value
        : !isEmpty(collectAmount) || collectAmount.length > 0
        ? collectAmount
        : "",
    PANNumber: vendorData.panNo ? vendorData.panNo : "",
    GSTIN: vendorData.gstNo ? vendorData.gstNo : "",
    sourceofsupply: billingData.city ? billingData.city : "",
    vendorCategoryId:
      vendorCategory || vendorCategory.length > 0 ? vendorCategory : "",
    creditperiod: vendorData.creditPeriod
      ? parseInt(vendorData.creditPeriod)
      : "",
    creditlimit: vendorData.creditLimit ? parseInt(vendorData.creditLimit) : "",
    currency: currencyData && !isEmpty(currencyData) ? currencyData : "",
    billingAddress: {
      address1: billingData.streetAddress,
      // address2: "Suite 456",
      country: "India",
      state: stateData,
      pincode: pincode,
      city: billingData.city,
    },
    shippingAddress:
      sameAs === true
        ? {
            address1: billingData.streetAddress,
            // address2: "Suite 456",
            country: "India",
            state: stateData,
            pincode: pincode,
            city: billingData.city,
          }
        : {
            address1: billingData.shippingStreetAddress,
            // address2: "Suite 456",
            country: "India",
            state: shippingStateData,
            pincode: shippingPincode,
            city: billingData.shippingCity,
          },

    createdBy: userId,
    // gstTypeId: "669e14490bbea68deec4b7f6",
    gstPercentageId:
      !isEmpty(gstPercentage) || gstPercentage.length > 0 ? gstPercentage : "",
    currencyId: currencyData && !isEmpty(currencyData) ? currencyData : "",
    creditBalance: vendorData.creditBalance
      ? parseInt(vendorData.creditBalance)
      : "",
  };

  const itemUpdateList = {
    vendorId: vendorData._id,
    organizationId: organizationId,
    vendorName: vendorName,
    displayName: displayName,
    mobileNo: vendorData.mobileNumber ? vendorData.mobileNumber : "",
    email: email ? email : "",
    openingBalance: vendorData.toCollectAmount
      ? parseInt(vendorData.toCollectAmount)
      : "",
    openingbalanceType:
      collectAmountValue && !isEmpty(collectAmountValue)
        ? collectAmountValue.value
        : !isEmpty(collectAmount) || collectAmount.length > 0
        ? collectAmount
        : "",
    PANNumber: vendorData.panNo ? vendorData.panNo : "",
    GSTIN: vendorData.gstNo ? vendorData.gstNo : "",
    sourceofsupply: billingData.city ? billingData.city : "",
    vendorCategoryId: !isEmpty(vendorCategoryId)
      ? vendorCategoryId
      : vendorCategory
      ? vendorCategory
      : "",
    creditperiod: vendorData.creditPeriod
      ? parseInt(vendorData.creditPeriod)
      : "",
    creditlimit: vendorData.creditLimit ? parseInt(vendorData.creditLimit) : "",
    currency: currencyData && !isEmpty(currencyData) ? currencyData : "",
    billingAddress: {
      address1: billingData.streetAddress,
      // address2: "Suite 456",
      country: "India",
      state: billingData.stateId ? billingData.stateId : stateData,
      pincode: pincode,
      city: billingData.city,
    },
    shippingAddress:
      sameAs === true
        ? {
            address1: billingData.streetAddress,
            // address2: "Suite 456",
            country: "India",
            state: billingData.stateId ? billingData.stateId : stateData,
            pincode: pincode,
            city: billingData.city,
          }
        : {
            address1: billingData.shippingStreetAddress,
            // address2: "Suite 456",
            country: "India",
            state: billingData.shippingStateId
              ? billingData.shippingStateId
              : stateData,
            pincode: shippingPincode,
            city: billingData.shippingCity,
          },

    createdBy: userId,
    // gstTypeId: "669e14490bbea68deec4b7f6",
    gstPercentageId:
      !isEmpty(gstPercentage) || gstPercentage.length > 0 ? gstPercentage : "",
    currencyId: !isEmpty(currencyName)
      ? currencyName
      : currency && !isEmpty(currency)
      ? currency
      : "",
    creditBalance: vendorData.creditBalance
      ? parseInt(vendorData.creditBalance)
      : "",
  };

  const itemListObj = Object.keys(vendorListData).forEach(
    (k) =>
      (vendorListData[k] == "" || vendorListData[k] == undefined) &&
      delete vendorListData[k]
  );
  const itemUpdateListObj = Object.keys(itemUpdateList).forEach(
    (k) =>
      (itemUpdateList[k] == "" || itemUpdateList[k] == undefined) &&
      delete itemUpdateList[k]
  );

  // console.log(vendorListData, "vendorListData");
  // console.log(itemUpdateList, "itemUpdateList");
  console.log(itemListObj, "itemListObj");
  // console.log(billingData, "billingData");
  console.log(itemUpdateListObj, "itemUpdateListObj");

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //create vendor list
  const createVendor = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 6000);
      api
        .post("/org/createvendor", vendorListData)
        .then((res) => {
          setTimeout(() => {
            dispatch(loadVendor(vendorListId));
            toast.success("Vendor Added Successfully");
            setTimeout(() => {
              history.push("/vendor-supplier");
            }, 1000);
          }, 2000);
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "An Error while adding the vendor");
          return Promise.reject(error);
        });
      // dispatch(createVendorList(vendorListData));
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //create vendor list
  const updateVendor = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 2000);
      console.log(itemUpdateList, "itemUpdateList");
      api
        .put("/org/updatevendor", itemUpdateList)
        .then((res) => {
          setTimeout(() => {
            dispatch(loadVendor(vendorListId));
            toast.success("Vendor Updated Successfully");
            setTimeout(() => {
              history.push("/vendor-supplier");
            }, 1000);
          }, 2000);
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "An Error while adding the vendor");
          return Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const [vendorButtonDisabled, setVendorButtonDisabled] = useState(false);

  // //category api integrations
  const createCategory = () => {
    if (!isEmpty(categoryName)) {
      setVendorButtonDisabled(true);
      setTimeout(() => {
        setVendorButtonDisabled(false);
      }, 6000);
      const categoryList = {
        categoryName: categoryName,
        organizationId: organizationId,
        shortCode: shortCode,
        description: description,
        createdBy: userId,
      };

      dispatch(createVendorCategoryList(categoryList));
      setTimeout(() => {
        dispatch(loadVendorCategory(vendorListId));
        setItemCategoryModal(false);
        setCategoryValidations(false);
        toast.success("Category Created successfully");
      }, 1000);
    } else {
      setCategoryValidations(true);
    }
  };

  //Initial loading

  const collectAmountDetails =
    balaceCollectOptions.length > 0
      ? balaceCollectOptions.find((data) => data.label === "To Pay")
      : "";

  useEffect(() => {
    setCollectAmount(collectAmountDetails ? collectAmountDetails.label : "");
    setVendorType({
      label: "Customer",
      value: "customer",
    });
    setCurrency("Indian Rupee");
    // setIsFormIncomplete(true)
    setSameAs(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(selectionVendorData, "selectionVendorData");

  //Update data from vendor selection page
  useEffect(() => {
    if (!isEmpty(selectionVendorData)) {
      const billingDataAddress =
        selectionVendorData && selectionVendorData.billingAddress.length > 0
          ? selectionVendorData.billingAddress[0]
          : "";
      const shippingDataAddress =
        selectionVendorData && selectionVendorData.shippingAddress.length > 0
          ? selectionVendorData.shippingAddress[0]
          : "";

      const gstPercentageId =
        selectionVendorData && selectionVendorData.gstPercentageId
          ? selectionVendorData.gstPercentageId
          : [];
      // const openingbalanceType =
      //   selectionVendorData && selectionVendorData.openingbalanceType
      //     ? selectionVendorData.openingbalanceType
      //     : [];
      const currencyId =
        selectionVendorData && selectionVendorData.currencyId
          ? selectionVendorData.currencyId[0]
          : [];
      const currencyName =
        selectionVendorData && selectionVendorData.currencyName
          ? selectionVendorData.currencyName
          : "";
      //Billing address section
      const billingStreetAddress = billingDataAddress.address1
        ? billingDataAddress.address1
        : "";
      const billingDataCity = billingDataAddress.city
        ? billingDataAddress.city
        : "";
      const billingStateAddress = billingDataAddress.state
        ? billingDataAddress.state
        : "";
      const billingPincode = billingDataAddress.pincode
        ? billingDataAddress.pincode
        : "";

      const stateNameData = billingDataAddress.stateName
        ? billingDataAddress.stateName
        : "";

      const billingAddressValues =
        billingDataAddress.address1 +
        ", " +
        billingDataAddress.city +
        ", " +
        stateNameData +
        ", " +
        billingDataAddress.country +
        " - " +
        billingDataAddress.pincode;

      //shipping address

      const shippingStreetAddress = shippingDataAddress.address1
        ? shippingDataAddress.address1
        : "";
      const shippingCity = shippingDataAddress.city
        ? shippingDataAddress.city
        : "";
      const shippingStateAddress = shippingDataAddress.state
        ? shippingDataAddress.state
        : "";
      const shippingPincode = shippingDataAddress.pincode
        ? shippingDataAddress.pincode
        : "";

      const shippingStateNameData = shippingDataAddress.stateName
        ? shippingDataAddress.stateName
        : "";
      const shippingAddressValues =
        shippingDataAddress.address1 +
        ", " +
        shippingDataAddress.city +
        ", " +
        shippingStateNameData +
        ", " +
        shippingDataAddress.country +
        " - " +
        shippingDataAddress.pincode;
      const vendorUpdatedValue = selectionVendorData
        ? selectionVendorData.vendorName
        : "";
      const vendorDisplayUpdatedValue = selectionVendorData
        ? selectionVendorData.displayName
        : "";
      setVendorName(vendorUpdatedValue);
      setDisplayName(vendorDisplayUpdatedValue);

      setVendorData({
        creditBalance: selectionVendorData
          ? selectionVendorData.creditBalance
          : "",
        mobileNumber: selectionVendorData ? selectionVendorData.mobileNo : "",
        email: selectionVendorData ? selectionVendorData.email : "",
        toCollectAmount: selectionVendorData
          ? selectionVendorData.openingBalance
          : "",
        gstNo: selectionVendorData ? selectionVendorData.GSTIN : "",
        panNo: selectionVendorData ? selectionVendorData.PANNumber : "",
        billingAddress: selectionVendorData.billingAddress
          ? billingAddressValues
          : "",
        shippingAddress: selectionVendorData.shippingAddress
          ? shippingAddressValues
          : "",
        sameAs: true,
        creditPeriod: selectionVendorData
          ? selectionVendorData.creditperiod
          : "",
        creditLimit: selectionVendorData ? selectionVendorData.creditlimit : "",
        _id: selectionVendorData._id,
      });
      setGstPercentage(gstPercentageId);
      setCollectAmount(collectAmountDetails ? collectAmountDetails.label : "");
      setCurrency(currencyName);
      setCurrencyName(currencyId);
      const selectionEmail = selectionVendorData
        ? selectionVendorData.email
        : "";
      setEmail(selectionEmail);
      setBillingData({
        streetAddress: billingStreetAddress,
        city: billingDataCity,
        shippingStreetAddress: shippingStreetAddress,
        shippingCity: shippingCity,
        stateId: billingStateAddress,
        shippingStateId: shippingStateAddress,
      });
      setStateData(stateNameData);
      setPincode(billingPincode);
      setShippingPincode(shippingPincode);
      setShippingStateData(shippingStateNameData);
      const vendorCategoryName =
        selectionVendorData && selectionVendorData.vendorCategoryName !== null
          ? selectionVendorData.vendorCategoryName
          : "";
      const vendorCategoryId =
        selectionVendorData && selectionVendorData.vendorCategory !== null
          ? selectionVendorData.vendorCategoryId
          : "";
      setVendorCategoryId(vendorCategoryId);
      setVendorCategory(vendorCategoryName);
    } else {
      setVendorData({
        creditBalance: "",
        mobileNumber: "",
        email: "",
        toCollectAmount: "",
        gstNo: "",
        panNo: "",
        billingAddress: "",
        shippingAddress: "",
        sameAs: "",
        creditPeriod: "",
        creditLimit: "",
        _id: "",
      });
      setCollectAmount(collectAmountDetails ? collectAmountDetails.label : "");
      setCurrency("Indian Rupee");
      setEmail("");
      setBillingData({
        streetAddress: "",
        city: "",
        shippingStreetAddress: "",
        shippingCity: "",
      });
      setStateData([]);
      setPincode("");
      setShippingPincode("");
      setShippingStateData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionVendorData]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Add Vendor | Mbook</title>
        </MetaTags>
      </div>

      {/* <Prompt
        when={isFormIncomplete}
        message="Are you sure you want to leave?"
      /> */}
      <FloatButton
        className="w-[50px] h-[50px]"
        type="primary"
        style={{
          margin: "-3px",
        }}
        onClick={() => setPartyFaq(!partyFaq)}
        icon={<QuestionCircleOutlined />}
      />
      <Row
        // onMouseEnter={() => setMouseHover(true)}
        // onMouseLeave={() => setMouseHover(false)}
        className="border-solid rounded-sm bg-[#ffffff]"
      >
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[20px] ml-2 mt-1 font-semibold"
              >
                {!isEmpty(selectionVendorData)
                  ? "Update Vendor"
                  : "Create Vendor"}
              </h1>
            </div>
            <div className="flex">
              <Tooltip
                title="Introducing custom fields -> Now you can add custom Vendor fields like Drug licence number, ID, etc.,"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setCustomFields(true)}
                  className="pointer-events-none opacity-1 border rounded-md mr-3 pt-1.5 pb-1.5 pr-6 pl-6 cursor-pointer"
                >
                  Vendor Settings <SettingOutlined />
                </div>
              </Tooltip>
              {!isEmpty(selectionVendorData) ? (
                <Button
                  disabled={isButtonDisabled ? true : false}
                  onClick={() => updateVendor()}
                  type="ml-3 bg-[blueviolet] pt-3 pb-3 pr-5 pl-5 text-[white] mr-3 primary"
                >
                  Update
                </Button>
              ) : (
                <Button
                  disabled={isButtonDisabled ? true : false}
                  onClick={() => createVendor()}
                  type="ml-3 bg-[blueviolet] hover:bg-[blueviolet] pt-3 pb-3 pr-5 pl-5 text-[white] mr-3 primary"
                >
                  Save
                </Button>
              )}
            </div>
          </div>
        </Col>
        <div
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "add-vendor-main-large-device"
              : windowDimensions.height > 830
              ? "add-vendor-main-extra-large-device"
              : "add-vendor-main"
          }
        >
          {/* <div className={mouseHover ? "add-party-main" : "w-[100%]"}> */}
          {/* General Details */}
          <Col span={24}>
            <Row className="w-[100%] bg-gray-50 p-1 border border-x-0 pl-5 pr-5 mt-3 mb-3">
              <h1 className="text-[16px] text-[#084d7b] font-semibold">
                {" "}
                General details{" "}
              </h1>
            </Row>
            <Row className="w-[100%] p-3.5">
              <Col span={6} className="pr-4">
                <Typography className="parties-input-required-label">
                  Vendor Name <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="vendorName"
                  value={vendorName}
                  onChange={(e) => {
                    setVendorName(e.target.value);
                    console.log(e.target.value, "partyName changes");
                    if (e.target.name === "vendorName") {
                      setDisplayName(e.target.value);
                    }
                  }}
                  placeholder="Enter Name"
                  className="p-2"
                />
                <p className="text-start text-[red] mt-2 mb-3">
                  {simpleValidator.current.message(
                    "vendorName",
                    vendorName,
                    "required"
                  )}
                </p>
              </Col>
              <Col span={6} className="pr-4">
                <Typography className="parties-input-label mb-1">
                  Display Name
                </Typography>
                <Input
                  name="displayName"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  placeholder="Enter Display Name"
                  className="p-2"
                />
              </Col>

              <Col span={6} className="pr-4">
                <Typography className="parties-input-label">
                  Mobile Number
                </Typography>
                <Input
                  name="mobileNumber"
                  maxLength={10}
                  value={vendorData.mobileNumber}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Mobile Number"
                  className="p-2 mt-1"
                />
              </Col>

              <Col span={6} className="pr-4">
                <Typography className="parties-input-label">Email</Typography>
                <Input
                  name="email"
                  value={email}
                  id="main-input"
                  onChange={validationChange}
                  placeholder="Enter Email"
                  className="p-2 mt-1"
                />
                <div
                  id="error-panel"
                  style={{
                    display: "none",
                    // marginTop: "-15px",
                    marginBottom: "10px",
                  }}
                >
                  {isEmpty(email) ? (
                    ""
                  ) : (
                    <p className="text-start text-[#ff0000]">
                      The email or mobile field is not valid
                    </p>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="w-[100%] pl-3.5 pr-3.5">
              <Col span={6} className="pr-3">
                <Typography className="parties-input-label">
                  Opening Balance
                </Typography>
                <Input
                  name="toCollectAmount"
                  value={vendorData.toCollectAmount}
                  onChange={(e) => handleChange(e)}
                  addonAfter={
                    <Select
                      value={collectAmount}
                      onChange={(value) => setCollectAmount(value)}
                      defaultValue={"To Pay"}
                      style={{
                        width: 110,
                        height: 45,
                      }}
                      options={balaceCollectOptions}
                    />
                  }
                  type="text"
                  prefix={"₹ "}
                  placeholder="0"
                  className="balance"
                />
              </Col>
              {/* <Col span={5} className="pr-4">
                <Typography className="parties-input-label mb-1">
                  Gst Percentage
                </Typography>
                <Select
                  style={{
                    width: "100%",
                    height: 40,
                  }}
                  value={gstPercentage}
                  onChange={(value) => setGstPercentage(value)}
                  // defaultValue={"customer"}
                  placeholder="Select Percentage"
                  options={
                    recordsMetaData ? recordsMetaData.gstPercentageOptions : []
                  }
                />
              </Col> */}
              <Col span={5} className="pr-4">
                <Typography className="parties-input-label">GSTIN</Typography>
                <Input
                  name="gstNo"
                  value={vendorData.gstNo}
                  onChange={(e) => handleChange(e)}
                  maxLength={12}
                  placeholder="ex:38XXXX97689XXXX80"
                  className="p-2 mt-1"
                />
              </Col>

              <Col span={3} className="pr-2 mt-[28px] ml-3">
                <Button
                  disabled
                  type="primary"
                  className="bg-[blueviolet] w-[90%]"
                >
                  {" "}
                  Get Details
                </Button>
              </Col>

              <Col span={4} className="pr-4">
                <Typography className="parties-input-label">
                  PAN Number
                </Typography>
                <Input
                  name="panNo"
                  value={vendorData.panNo}
                  onChange={(e) => handleChange(e)}
                  maxLength={10}
                  placeholder="Enter party PAN Number"
                  className="p-2 mt-1"
                />
              </Col>
            </Row>
            <Row className="w-[100%] pl-3.5 pr-3.5">
              <Col span={24} className="pr-4 mb-2">
                <h1 className="text-[#0d2433] font-poppins text-[12px] mt-4">
                  Note: You can auto populate party details from GSTIN
                </h1>
              </Col>
              <Divider
                style={{
                  color: "red",
                }}
              />
            </Row>
            <Row className="pl-4 pr-4 mb-2">
              <Col span={6} className="pr-4">
                <Typography className="parties-input-label mb-1">
                  Vendor Category
                </Typography>
                <Select
                  style={{
                    width: "100%",
                    height: 40,
                  }}
                  value={vendorCategory}
                  onChange={(value) => setVendorCategory(value)}
                  placeholder="Select Categories"
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider
                        style={{
                          margin: "8px 0",
                        }}
                      />
                      <div className="w-[100%]">
                        <Button
                          type="dashed"
                          className="w-[100%]"
                          icon={<PlusOutlined />}
                          onClick={() => {
                            setCategoryAdditionalFields(false);
                            setItemCategoryModal(true);
                          }}
                        >
                          Add item
                        </Button>
                      </div>
                    </>
                  )}
                  options={categoryOptions}
                />
              </Col>
              <Col span={6} className="pr-4">
                <Typography className="parties-input-label mb-1">
                  Currency
                </Typography>
                <Select
                  style={{
                    width: "100%",
                    height: 40,
                  }}
                  value={currency}
                  onChange={(value) => setCurrency(value)}
                  placeholder="Select Currency"
                  options={
                    recordsMetaData ? recordsMetaData.currencyOptions : []
                  }
                />
              </Col>
            </Row>
          </Col>

          {/* Address Details */}
          <Col span={24} className="mb-4">
            <Row className="w-[100%] mt-2 bg-gray-50 p-1 border border-x-0 pl-5 pr-5 mt-3 mb-3">
              <h1 className="text-[16px] text-[#084d7b] font-semibold">
                {" "}
                Address
              </h1>
            </Row>
            <Row className="w-[100%] p-3.5">
              <Col span={12} className="pr-4">
                <Typography className="parties-input-required-label">
                  Billing Address <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input.TextArea
                  name="billingAddress"
                  onClick={() => setBillingModal(true)}
                  value={vendorData.billingAddress}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Billing Address"
                  className="pt-2 mt-1 pb-5 text-semibold"
                />
                <p className="text-start text-[red] mt-2 mb-3">
                  {simpleValidator.current.message(
                    "vendorName",
                    vendorData.billingAddress,
                    "required"
                  )}
                </p>
              </Col>

              <Col span={12} className="pr-4">
                <div className="flex justify-between">
                  <Typography className="parties-input-label">
                    Shipping Address
                  </Typography>
                  <div className="flex">
                    <Checkbox
                      type="checkbox"
                      name="sameAs"
                      height={14}
                      width={14}
                      defaultChecked
                      value={sameAs}
                      onChange={(e) => setSameAs(e.target.checked)}
                      className="text-[#084d7b]"
                    >
                      Same as Billing Address
                    </Checkbox>
                  </div>
                </div>
                <Input.TextArea
                  name="shippingAddress"
                  onClick={() => {
                    if (sameAs === false) {
                      setBillingModal(true);
                      setAddressMode("Shipping");
                    }
                  }}
                  disabled={sameAs === true ? true : false}
                  value={vendorData.shippingAddress}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Shipping Address"
                  className="pt-2 mt-1 pb-5 text-semibold"
                />
              </Col>
              <Divider />
              <Col span={6} className="pr-4">
                <Typography className="parties-input-label">
                  Credit Period
                </Typography>
                <Tooltip
                  title="Amount of days party is allowed to wait before making the payment for an invoice"
                  rootClassName="text-[12px]"
                  placement="top"
                >
                  <Input
                    name="creditPeriod"
                    value={vendorData.creditPeriod}
                    onChange={(e) => handleChange(e)}
                    suffix={"Days"}
                    className="w-[100%] h-[35px] p-2 mt-1"
                  />
                </Tooltip>
              </Col>

              <Col span={6} className="pr-4">
                <Typography className="parties-input-label">
                  Credit Limit
                </Typography>
                <Tooltip
                  title="Maximum amount of outstanding balance this party can hold on credit"
                  rootClassName="text-[12px]"
                  placement="top"
                >
                  <Input
                    name="creditLimit"
                    value={vendorData.creditLimit}
                    onChange={(e) => handleChange(e)}
                    prefix={"₹ "}
                    placeholder="0"
                    className="p-2 mt-1"
                  />
                </Tooltip>
              </Col>
              {/* <Col span={6} className="pr-4">
                <Typography className="parties-input-label">
                  Credit Balance
                </Typography>
                <Tooltip
                  title="Amount of days party is allowed to wait before making the payment for an invoice"
                  rootClassName="text-[12px]"
                  placement="top"
                >
                  <Input
                    name="creditBalance"
                    value={vendorData.creditBalance}
                    onChange={(e) => handleChange(e)}
                    prefix={"₹ "}
                    placeholder="0"
                    className="p-2 mt-1"
                  />
                </Tooltip>
              </Col> */}
            </Row>
          </Col>
          {/* Custom field Details */}
          <Col span={24} className="mb-[35px]">
            <Row className="w-[100%] mt-2 bg-gray-50 p-1 border border-x-0 pl-5 pr-5 mt-3 mb-3">
              <h1 className="text-[16px] text-[#084d7b] font-semibold">
                {" "}
                Custom Field
              </h1>
            </Row>
            <Row className="w-[100%] p-3.5">
              <Col span={24} className="text-center">
                <Image src={customFieldsLogo} className="opacity-20" />
                <div className="text-center mt-[-10px]">
                  <h1 className="flex justify-center mb-2 text-[18px] text-[#084d7b] mt-1">
                    Store more information about your vendor by adding custom
                    fields from{" "}
                    <p className="text-[#000000] ml-2"> Vendor Settings</p>
                  </h1>
                  <Button
                    onClick={() => setCustomFields(true)}
                    type="primary"
                    className="bg-[blueviolet] text-[white]"
                  >
                    Add Custom Fields
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </div>

        {/* Custom fields modal */}
        <Modal
          open={customFields}
          title="Party Settings"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: customFieldsData.length > 0 ? false : true,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              {/* <Button>Custom Button</Button> */}
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            // className="w-[110%] ml-[-24px]"
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="flex">
            <p className="leading-tight font-poppins">
              Now you can add custom party fields like Birthday, ID Number, etc.
            </p>
            <Image src={customModalLogo} />
          </div>
          {/* {(customFieldsData &&
            customFieldsData.length > 0 &&
            customFieldsAdd == true) ||
          (customFieldsData &&
            customFieldsData.length > 0 &&
            !isEmpty(customFieldsData[0].fieldName)) ? ( */}
          <div>
            <Divider
              style={{
                borderWidth: "0.2px",
                width: "110%",
                marginLeft: "-24px",
              }}
            />
            {customFieldsData.map((data, index) => {
              return (
                <div key={index} className="mb-2">
                  {index !== 0 ? (
                    <Divider
                      style={{
                        borderWidth: "0.2px",
                        width: "110%",
                        marginLeft: "-24px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                  <div className="flex justify-between mt-[-15px] mb-[-6px]">
                    <Input
                      name="fieldName"
                      value={data.fieldName}
                      placeholder="Enter field name"
                      className="w-[60%]"
                      onChange={(e) =>
                        handleCustomFieldsChange(e, "fieldName", index)
                      }
                    />
                    <CloseOutlined
                      onClick={() => removeCustomFields(index)}
                      type="primary"
                      className="ml-3 text-[red] cursor-pointer"
                      size={"large"}
                    />{" "}
                  </div>
                </div>
              );
            })}
          </div>
          {/* ) : (
            ""
          )} */}

          <Row className="w-[110%] ml-[-23px] mt-2 bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mt-3 mb-3">
            <h1
              onClick={() => addCustomFields()}
              className="cursor-pointer text-[14px] text-[#084d7b] font-semibold"
            >
              {" "}
              <PlusOutlined /> Add Custom Field
            </h1>
          </Row>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* Billing modal */}
        <Modal
          open={billingModal}
          title="Vendor"
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onClose={() => setBillingModal(false)}
          onCancel={() => setBillingModal(false)}
          onOk={billingAddressSubmit}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
          width={600}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
          {addressMode === "Shipping" ? (
            <Row>
              <Col span={24}>
                <Typography className="parties-input-required-label">
                  Street Address <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input.TextArea
                  name="shippingStreetAddress"
                  value={billingData.shippingStreetAddress}
                  onChange={(e) => billingModalChange(e)}
                  placeholder="Enter Street Address"
                  className="pt-2 pb-5 text-semibold"
                />
              </Col>
              <Col span={12} className="mt-1">
                <Typography className="parties-input-required-label">
                  State<p className="text-[red] mx-1">*</p>
                </Typography>
                <Select
                  style={{
                    width: 250,
                    height: 40,
                  }}
                  value={shippingStateData}
                  onChange={(e) => setShippingStateData(e)}
                  placeholder="Select State"
                  options={recordsMetaData ? recordsMetaData.stateOptions : []}
                />
              </Col>
              <Col span={12} className="mt-2">
                <Typography className="parties-input-required-label">
                  Pincode <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="shippingPincode"
                  value={shippingPincode}
                  onChange={(e) => {
                    const name = "shippingPincode";
                    const validationRules = {
                      shippingPincode: /^[0-9]*$/,
                    };
                    if (validationRules[name]) {
                      if (
                        validationRules[name].test(e.target.value) ||
                        e.target.value === ""
                      ) {
                        setShippingPincode(e.target.value);
                      }
                    }

                    axios
                      .get(
                        `https://api.postalpincode.in/pincode/${e.target.value}`
                      )
                      .then((res) => {
                        console.log(res, "res");
                        if (e.target.value.length === 6) {
                          setBillingData({
                            ...billingData,
                            shippingCity:
                              res &&
                              res.data &&
                              res.data.length > 0 &&
                              res.data[0].PostOffice !== null
                                ? res.data[0].PostOffice[0].District
                                : "",
                          });
                        } else {
                          setBillingData({
                            ...billingData,
                            shippingCity: "",
                          });
                        }
                      });
                  }}
                  maxLength={6}
                  placeholder="Enter pincode"
                  className="p-2 text-semibold"
                />
              </Col>
              <Col span={24} className="mt-2">
                <Typography className="parties-input-label">
                  City <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="shippingCity"
                  value={billingData.shippingCity}
                  onChange={(e) => billingModalChange(e)}
                  placeholder="Enter City"
                  className="p-2 text-semibold"
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col span={24}>
                <Typography className="parties-input-required-label">
                  Street Address <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input.TextArea
                  name="streetAddress"
                  value={billingData.streetAddress}
                  onChange={(e) => billingModalChange(e)}
                  placeholder="Enter Street Address"
                  className="pt-2 pb-5 text-semibold"
                />
              </Col>
              <Col span={12} className="mt-1">
                <Typography className="parties-input-label">
                  State <p className="text-[red] mx-1">*</p>
                </Typography>
                <Select
                  style={{
                    width: 250,
                    height: 40,
                  }}
                  value={stateData}
                  onChange={(e) => setStateData(e)}
                  placeholder="Select State"
                  options={recordsMetaData ? recordsMetaData.stateOptions : []}
                />
              </Col>
              <Col span={12} className="mt-2">
                <Typography className="parties-input-label">
                  Pincode <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="pincode"
                  value={pincode}
                  onChange={(e) => {
                    const name = "pincode";
                    const validationRules = {
                      pincode: /^[0-9]*$/,
                    };
                    if (validationRules[name]) {
                      if (
                        validationRules[name].test(e.target.value) ||
                        e.target.value === ""
                      ) {
                        setPincode(e.target.value);
                      }
                    }

                    axios
                      .get(
                        `https://api.postalpincode.in/pincode/${e.target.value}`
                      )
                      .then((res) => {
                        console.log(res, "res");
                        if (e.target.value.length === 6) {
                          setBillingData({
                            ...billingData,
                            city:
                              res &&
                              res.data &&
                              res.data.length > 0 &&
                              res.data[0].PostOffice !== null
                                ? res.data[0].PostOffice[0].District
                                : "",
                          });
                        } else {
                          setBillingData({
                            ...billingData,
                            city: "",
                          });
                        }
                      });
                  }}
                  maxLength={6}
                  placeholder="Enter pincode"
                  className="p-2 text-semibold"
                />
              </Col>
              <Col span={24} className="mt-2">
                <Typography className="parties-input-label">
                  City <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="city"
                  value={billingData.city}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter City"
                  className="p-2 text-semibold"
                />
              </Col>
            </Row>
          )}

          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>
        {/* party faq modal */}
        <Modal
          open={partyFaq}
          title="Parties"
          closeIcon
          maskClosable={false}
          onClose={() => setPartyFaq(false)}
          onCancel={() => setPartyFaq(false)}
          footer={(_, { CancelBtn }) => (
            <>
              <CancelBtn />
            </>
          )}
          width={600}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />

          <Collapse
            items={partyFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
          />
        </Modal>
        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);

            history.push("/vendor-supplier");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div
                // to={{
                //   pathname: "/parties",
                // }}
                className="mr-3"
              >
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
        {/* New category modal */}
        <Modal
          open={itemCategoryModal}
          title={"Create Category"}
          onOk={() => {
            createCategory();
          }}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: vendorButtonDisabled ? true : false,
          }}
          width={450}
          onCancel={() => setItemCategoryModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "1px",
              width: "112%",
              marginLeft: "-24px",
            }}
          />
          <Col span={24} className="mt-[-5px]">
            <Typography
              className="uppercase mb-1"
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
              }}
            >
              Category Name
            </Typography>
            <Input
              name="categoryName"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="Enter Category Name"
              className="p-2"
            />
            <p className="text-start text-[red] mt-2 mb-3">
              {categoryValidations === true
                ? "category name field is required"
                : ""}
            </p>
          </Col>
          {categoryAdditionalFields ? (
            <>
              {" "}
              <Col span={24} className="flex justify-end">
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => setCategoryAdditionalFields(false)}
                  className="cursor-pointer text-[#d54041] text-[13px]"
                >
                  Remove
                </div>
              </Col>
              <Col span={24}>
                <Typography
                  className="uppercase mb-1"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  Short Code
                </Typography>
                <Input
                  name="shortCode"
                  value={shortCode}
                  onChange={(e) => setShortCode(e.target.value)}
                  placeholder="Enter Short Code"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mb-[50px] mt-2">
                <Typography
                  className="uppercase mb-1"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  Description
                </Typography>
                <Input.TextArea
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter Description"
                  className="p-3"
                />
              </Col>
            </>
          ) : (
            <div
              style={{
                fontFamily: "Poppins",
              }}
              onClick={() => setCategoryAdditionalFields(true)}
              className="cursor-pointer flex text-[#4096ff] mt-2 text-[13px] mb-4"
            >
              <PlusOutlined className="mr-2" /> Additonal Fields
            </div>
          )}
        </Modal>
      </Row>
      {/* <Prompt
        when={!isEmpty(vendorData) || !isEmpty(vendorType)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

AddVendor.propTypes = {
  onSignin: PropTypes.any,
  location: PropTypes.any,
  recordsMetaData: PropTypes.any,
};

export default AddVendor;
